if (document.querySelector('.employee')) {
    const employees = document.querySelectorAll('.employee');

    employees.forEach(employee => {
        employee.addEventListener('mouseenter', (e) => {
            const imageHover = employee.querySelector('img').getAttribute('data-img-hover');

            if (imageHover) {
                employee.querySelector('img').setAttribute('src', imageHover);
            }
        });

        employee.addEventListener('mouseleave', (e) => {
            const imageHover = employee.querySelector('img').getAttribute('data-img-hover');
            const currentImage = employee.querySelector('img').getAttribute('data-img');

            if (imageHover) {
                employee.querySelector('img').setAttribute('src', currentImage);
            }
        });
    });
}
